"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var core_1 = require("@dynamynd/core");

var formik_1 = require("formik");

var react_1 = __importStar(require("react"));

var Yup = __importStar(require("yup"));

var enums_1 = require("../../../enums");

var DescriptionParagraph_1 = require("./DescriptionParagraph");

var ResendCodeLink_1 = __importDefault(require("./ResendCodeLink"));

var UpdatePasswordForm =
/** @class */
function (_super) {
  __extends(UpdatePasswordForm, _super);

  function UpdatePasswordForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.description = "Enter the six digits code that you've received on your email or phone number and reset your password.";
    _this.initialValues = {
      code: '',
      password: '',
      passwordConfirm: ''
    };
    _this.validationSchema = Yup.object().shape({
      code: Yup.string().min(6, core_1.ValidationErrorMessagesEnum.resetPasswordCodeLength).max(6, core_1.ValidationErrorMessagesEnum.resetPasswordCodeLength).required(core_1.ValidationErrorMessagesEnum.requiredField),
      password: Yup.string().required(core_1.ValidationErrorMessagesEnum.passwordRequired).min(8, core_1.ValidationErrorMessagesEnum.passwordLength),
      passwordConfirm: Yup.string().when('password', {
        is: function is(v) {
          return !!v;
        },
        then: Yup.string().required(core_1.ValidationErrorMessagesEnum.confirmPasswordRequired),
        otherwise: Yup.string().oneOf(['password'], core_1.ValidationErrorMessagesEnum.passwordShouldMatch)
      }).when('password', {
        is: function is(v) {
          return !!v;
        },
        then: Yup.string().oneOf([Yup.ref('password')], core_1.ValidationErrorMessagesEnum.passwordShouldMatch)
      }).min(8, core_1.ValidationErrorMessagesEnum.passwordLength)
    });

    _this.renderFields = function (props) {
      var isSubmitting = props.isSubmitting,
          setSubmitting = props.setSubmitting;
      var updating = _this.props.updating;

      if (updating !== isSubmitting) {
        setSubmitting(updating);
      }

      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: enums_1.FieldNames.code,
        label: enums_1.FieldLabels.forgotPasswordCode,
        isDisabled: isSubmitting,
        accessibilityLabel: "Enter Validation Code"
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: enums_1.FieldNames.password,
        label: enums_1.FieldLabels.forgotPasswordPasswordLabel,
        isDisabled: isSubmitting,
        isSecure: true,
        accessibilityLabel: "New Password"
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: enums_1.FieldNames.passwordConfirm,
        label: enums_1.FieldLabels.forgotPasswordConfirmPasswordLabel,
        isDisabled: isSubmitting,
        isSecure: true,
        accessibilityLabel: "Confirm New Password"
      }, props)));
    };

    return _this;
  }

  UpdatePasswordForm.prototype.render = function () {
    var _a = this.props,
        onSubmit = _a.onSubmit,
        renderForm = _a.renderForm;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(DescriptionParagraph_1.DescriptionParagraph, null, this.description), react_1.default.createElement(formik_1.Formik, {
      initialValues: this.initialValues,
      onSubmit: onSubmit,
      validationSchema: this.validationSchema,
      enableReinitialize: true,
      render: renderForm(this.renderFields)
    }), react_1.default.createElement(ResendCodeLink_1.default, null));
  };

  return UpdatePasswordForm;
}(react_1.PureComponent);

exports.default = components_lib_1.withFormUtils(UpdatePasswordForm);